export default {
  // 考勤
  attendance: {
    attendance: '考勤',
    attendanceMange: '考勤管理',
    attendanceNote: '急速打卡，轻松统计',
    clockRule: '打卡规则',
    attendanceMethod: '考勤方式',
    shiftMangae: '班次管理',
    workforceManage: '排班管理',
    otherSet: '其他设置',
    associatedApprovalForm: '关联审批单',
    plugManage: '插件管理',
    attendanceStatistics: '考勤统计',
    addAddress: '添加地址',
    addWIFI: '添加WiFi',
    placeAttendance: '地点考勤',
    attendanceName: '考勤名称',
    attendanceAdress: '考勤地址',
    attendanceNum: '考勤人数',
    attendanceType: '考勤类型',
    attendanceDate: '考勤日期',
    validRange: '有效范围',
    m: '米',
    WIFIattendance: 'WiFi考勤',
    WIFIname: 'WiFi名称',
    macAddress: 'MAC地址',
    setWIFI: '设置WiFi',
    wifiName_empty: '请输入WiFi名称',
    wifiName_error: '名称尽量保持与考勤WiFi名称一致，避免员工产生误解。',
    mac_empty: '请输入MAC地址',
    mac_error: '请输入正确的MAC地址',
    macTip: '不会填写MAC地址？手机设置轻松完成。',
    tutorial: '点我看教程',
    attendanceWayDeleteTip:
      '提示：删除后不可恢复，并且应用该考勤地点/WiFi的考勤组将不再能够使用该地址/WiFi打卡',
    leastOneAddress: '请至少选定一个地址',
    leastOneValidRange: '请至少选定一个有效范围',
    shiftsName: '班次名称',
    maxLengthMust: '最多输入6个字符，必填',
    attendanceTime: '考勤时间',
    commutingTimes: '上下班次数',
    workOnceDay: '1天1次上下班',
    workTwiceDay: '1天2次上下班',
    workthreeDay: '1天3次上下班',
    addShift: '添加班次',
    times: '次数',
    shift: '班次',
    clockTime: '打卡时间',
    clockTimeLimit: '打卡时间限制',
    forceClock: '强制打卡',
    first: '第1次',
    second: '第2次',
    third: '第3次',
    gotoWork: '上班',
    offDuty: '下班',
    nextDay: '次日',
    needClock: '需要打卡',
    noNeedClock: '不需要打卡',
    restTime: '休息时间',
    breakStart: '休息开始',
    breakEnd: '休息结束',
    break: '休息',
    time: '时间',
    select: '选择',
    ruleEffectiveTime: '选择规则生效时间',
    effectiveImmediatelyTip: '立即生效：今日考勤结果将按新规则重算',
    effectiveTomorrow: '明天生效',
    effectiveImmediately: '立即生效',
    anyTimeClock: '任何时间都能打卡',
    workBefore15: '上班前15分钟内开始打卡',
    workBefore30: '上班前30分钟内开始打卡',
    workBefore60: '上班前60分钟内开始打卡',
    workBefore90: '上班前90分钟内开始打卡',
    workBefore120: '上班前120分钟内开始打卡',
    workBefore150: '上班前150分钟内开始打卡',
    workBefore180: '上班前180分钟内开始打卡',
    workAfter15: '下班后15分钟内开始打卡',
    workAfter30: '下班后30分钟内开始打卡',
    workAfter60: '下班后60分钟内开始打卡',
    workAfter90: '下班后90分钟内开始打卡',
    workAfter120: '下班后120分钟内开始打卡',
    workAfter150: '下班后150分钟内开始打卡',
    workAfter180: '下班后180分钟内开始打卡',
    shiftsName_empty: '班次名称不能为空',
    timeSequence_error: '请按时间顺序设置时间点',
    addAttendanceGroup: '添加考勤组',
    fixedShiftSystem: '固定班制',
    schedulingSystem: '排班制',
    freeWorkingHours: '自由工时',
    weekly: '每周',
    clockAtAnyTim: '不设置班次，随时打卡',

    scheduling: '排班',
    stepOne: '第一步：下载排班列表',
    stepTwo: '第二步：导入排班列表',
    attendanceScheduling: '考勤排班',
    schedulingPeriod: '排班周期',
    adjusted: '已调整',
    item: '项',
    recover: '恢复',
    addRosterPeriod: '添加排班周期',
    cycleName: '周期名称',
    cycleNameLength: '请输入周期名称，限制6个字以内',
    cucleDay: '周期天数',
    cycle: '周期',
    shiftTime: '班次时间',
    di: '第',
    restDay: '当天休息',
    hugh: '休',
    discardSave: '是否确定放弃保存',
    dataNotSaved: '当月排班数据尚未保存',
    attendanceManage: '考勤管理员',
    saveSet: '保存设置',
    clockReminder: '打卡提醒',
    wordTimeBefore: '上班时间前',
    remindWorkCard: '分钟，提醒员工打上班卡。',
    afterHours: '下班时间后',
    remindClockOut: '分钟，提醒员工打下班卡。',
    listSet: '榜单设置',
    allGroupTogether: '所有考勤组都统计在一起',
    attendanceGroupstatistics: '按考勤组分开统计',
    earlyArrivalList: '早到榜',
    listStatistics: '榜单统计方式',

    statisticsEveryDayBefore: '统计每天前',
    punchCardSituation: '名的打卡情况。',
    diligenceList: '勤勉榜',
    statisticsEveryMonthBefore: '统计每个月前',
    lateList: '迟到榜',
    lateStatisticsMethod: '迟到统计方式',
    lateness_error: '按迟到次数排序。迟到次数越多排序越靠前，次数相同则按迟到时长排序',
    lateHours_error: '按迟到时长排序。迟到时长越长排序越靠前，迟到时长相同则按迟到次数排序。',
    lateArrivalAndLateDeparture: '晚到晚走',
    firstDayLeaveLate: '第一天下班后晚走',
    nextDayLeaveLate: '第二天上班后晚到',
    humanizedShift: '人性化班次',
    everyMonthLate: '每个月累计允许迟到',
    lateOneTimeAllowed: '单次允许迟到',
    lateOneTimeAllowed2: '累计允许迟到',
    singleLate: '单次迟到超过',
    singleLeaveEarly: '单次早退超过',
    absenteeismRules: '旷工规则',
    recordedAbsenteeism: '分钟，记为旷工。',
    absenteeismRulesTip: '默认旷工规则：上下班都未打卡记为旷工',
    error1: '只能输入大于等于0的整数',
    error2: '只能输入大于0的整数',
    late: '迟到',
    lateTime: '迟到时间',
    leaveEarly: '早退',
    lateTime_error: '允许迟到时间不得大于旷工规则设定时间',
    absenteeismRules_error: '旷工规则设定时间不得小于允许迟到时间',
    lateDepartureTime: '晚走时间',
    workBefore: '上班前',
    goOffWorkBefore: '下班前',
    ci: '次',
    articlePage: '条/页',
    numberShifts: '班人数',
    scheduleByDay: '按天排班',
    scheduleByCycle: '按周期排班',
    modifyshift: '修改该员工当天班次',
    thisDayToEndOfMonth: '从该天开始周期排班至月底',
    name: '姓名',
    statistics: '统计人数',
    modifyTips: '只能修改当前月份及上个月的排班',
    attendanceGroup: '考勤组',
    attendanceGroupName: '考勤组名称',
    attendanceGroupNameLength10: '请输入考勤名称，限制10个字以内',
    attendanceName_empty: '考勤名称不能为空',
    attendanceOfficer: '考勤人员',
    attendanceOfficer_empty: '考勤人员不能为空',
    noAttendanceRequired: '无需考勤人员',
    sameTime: '每天考勤时间一样',
    sameTimeTip: '适用于：IT、金融、文化传媒、政府/事业单位、教育培训等行业',
    weekdays: '工作日',
    legalHolidays: '法定节假日自动排休',
    customAttendanceTime: '自定义设置考勤时间',
    customAttendanceTimeTip: '适用于：餐饮、制造、物流贸易、客户服务、医院等行业',
    shiftTip: '保存打卡规则之后，请到“排班管理”里面给当前规则里面的成员设置排班',
    noShiftTip: '适用于：班次没有规律，装修，家政，物流等计算工作时长的行业',
    specialClock: '特殊打卡',
    mustPunchDate: '必须打卡日期',
    date: '日期',
    editShift: '编辑班次',
    noClockDate: '不用打卡日期',
    setWeekdays: '设置工作日',
    attendanceStartTime: '考勤开始时间',
    attendanceStartTimeTip: '每天几点开始新一天的考勤',
    attendanceTypeTip: '以下方式满足一项，考勤组成员即可完成考勤',
    attendanceTypeTip1: '根据办公地点考勤（可添加多个考勤地点）',
    addAttendanceAddress: '添加考勤地址',
    attendanceTypeTip2: '根据WiFi考勤（精确定位到办公室内，可添加多个办公WiFi）',
    addWIFIAddress: '添加WiFi地址',
    allowClock: '允许外勤打卡',
    punchClock: '人脸识别打卡',
    addData: '添加日期',
    multipleShiftTypes: '可选择多种班次类型',
    setUpShifts: '设置班次',
    selectShift: '选择班次',
    pleasSelectShift: '请选择班次',
    attendanceWifiAddress_error: '根据办公地点考勤与根据WiFi考勤必须设置一项',
    dateRepeated: '日期已重复',
    data_empty: '日期不能为空',
    redPacket: '红包',
    redPacketNote: '考勤成功后有红包奖励，激励员工',
    addRule: '添加规则',
    rewardContent: '奖励内容',
    numberAwards: '奖励数量',
    rewardAmount: '奖励金额',
    shake: '摇一摇',
    faceRecognition: '人脸识别',
    faceRecognition2: '精准识别人脸，拍照完成考勤打卡',
    fastPunch: '极速打卡',
    fastPunch2: '只需要在考勤时间段内打开app，系统就会自动帮您完成打卡',
    connectAttendanceMachine: '连接考勤机',
    connectAttendanceMachine2: '打通线上线下双平台，考勤数据全汇总（仅支持指定考勤机）',
    redPacketSet: '红包设置',
    redPacketSetTip1: '早到榜是每天更新的榜单，统计的是每天最早来机构的员工。',
    redPacketSetTip2: '红包奖励为即时发放，只要打卡在获奖范围，就会发送红包。',
    topOfList: '排行榜前',
    ranking: '名',
    distributionMethod: '分配方式',
    average: '均分',
    random: '随机',
    custom: '自定义',
    allAttendanceRecords: '原始打卡记录',
    dailySummary: '每日汇总',
    monthlySummary: '每月汇总',
    exceptionRecord: '异常记录',
    fieldName: '字段名称',
    clockAddress: '打卡地址',
    clockResults: '打卡结果',
    week: '星期',
    remark: '备注',
    clockEquipment: '打卡设备',
    fieldPersonnel: '外勤',
    month: '月份',
    attendanceDays: '出勤天数',
    daysOff: '休息天数',
    workingHours: '工作时长',
    lateTimes: '迟到次数',
    lateRecord: '迟到记录',
    lengthOfBeingLate: '迟到时长',
    earlyLeaveTimes: '早退次数',
    earlyLeaveRecord: '早退记录',
    lengthOfEarlyLeave: '早退时长',
    cardMissingTimes: '上班缺卡次数',
    cardMissingTimes2: '打卡时间：上班缺卡',
    cardMissingRecord: '缺卡记录',
    numberCardsMissingFromWork: '下班缺卡次数',
    numberCardsMissingFromWork2: '打卡时间：下班缺卡',
    absenteeismDays: '旷工天数',
    absenteeismRecord: '旷工记录',
    attendanceRequiredDays: '应出勤天数',
    lateAbsenteeism: '迟到旷工',
    earlyLeaveAbsenteeism: '早退旷工',
    clockTimeAbsenteeism: '打卡时间：旷工',
    leave: '请假',
    overtime: '加班',

    yymmdd: 'yyyy年MM月dd日',
    yymmddhhmm: 'yyyy年MM月dd日 HH:mm',
    editRecord: '修改记录',
    normal: '正常',
    modifyReason: '修改原因',
    minute_empty: '分钟不能为空',
    modifyTip1: '将打卡结果“',
    modifyTip2: '”修改为“',
    modifyTip3: '修改理由',
    arrive: '到',
    goout: '外出',
    changeFlight: '更改班次',
    evection: '出差',
    reissue: '补卡',

    addPersonnel: '添加人员',
    synchronousPersonnel: '同步人员',
    serialNumber: '序号',
    machineNumber: '考勤机中对应人员工号',
    attendanceMachine: '考勤机',
    attendanceMachineManufacturer: '考勤机厂商',
    attendanceMachineName: '考勤机名称',
    attendanceMachineName_error: '考勤机名称不能为空',
    attendanceMachineSN: '考勤机SN',
    timingTime: '定时时间',
    timingTime_error: '定时时间不能为空',
    synchronousTime_error: '同步时间不能为空',
    attendanceMachineSN_error: '考勤机SN不能为空',
    timeInterval_error: '时间间隔不能为空',
    attendanceMachineTip: '考勤机-设备信息-序列号',
    attendanceMachineDeleteTip: '确认要删除该考勤机吗？',
    off: '断开',
    sameAttendanceGroup: '仅针对同一考勤组排班人员进行更换',
    signatureCardType: '签卡类型',
    cardReplacementTime: '补卡时间',
    overtimeType: '加班类型',
    leaveType: '请假类型',
    why: '原因',
    selected: '已选择',
    arecord: '条记录',
    importedTip: '请按照数据模板的格式准备要导入的数据。',
    notes: '注意事项',
    notes1: '1、模板中的表头名称不可更改，表头行不能删除；',
    notes2: '2、导入格式为xlsx，最多只允许上传10000条，文件大小不超过20M；',
    notes3: '3、姓名、考勤组、考勤日期、考勤时间、打卡时间为必填；',
    notes4: '4、若姓名相同，请必须填写工号匹配人员考勤；',
    notes5: '5、导入的数据仅针对缺卡状态数据，未缺卡状态不可导入更新；',
    importTemplate: '点此下载数据导入模板',
    addFile: '添加文件',
    startImporting: '开始导入',
    synchronizingData: '同步历史数据',
    startSync: '开始同步',
    laterData: '之后的数据',
    realTimeSync: '实时同步',
    timing: '定时',
    syncBetween: '间隔同步',
    attendanceMachineTip2: '请配置需要获取哪些考勤机数据，以及配置每台考勤机需要同步人员。',
    every: '每隔',
    getAttendanceData: '分钟获取一次考勤数据',
    effectiveStartTime: '有效开始时间',
    effectiveEndTime: '有效结束时间',
    startAndEndTime_error: '开始时间不能大于等于结束时间',
    overtimeTime_empty: '加班时长不能为空',
    overtimeTime_error: '加班时长格式错误',
    yuanyin_error: '原因不能为空',
    fileFormatError: '文件格式错误',
    onelateminute: '单次迟到分钟',
    cumulativelateminute: '累计迟到分钟',
    autoMatchTip: '未排班时，智能化匹配班次，也可手动修改班次',
    correctedstate: '修正状态',
    cardreplacementrule: '补卡规则',
    annualleaverule: '年假规则',
    overtimerule: '加班规则',
    lackofapprovalcard: '审批通过后，该时间段内的考勤“缺卡”状态将会被自动修正为“正常”。',
    afterapprovalmonthlystatistics: '审批通过后，该审批单会纳入考勤月统计当中',
    cardreplacementtimefield: '补卡时间对应字段',
    starttimecorrespondstotime: '开始时间对应时间',
    endtimecorrespondstotime: '结束时间对应时间',
    fieldcorrespondingtolength: '时长对应字段',
    itemTip1: '该项用于年假和调休假余额扣除所使用',
    numberofcardrepayments: '限制补卡次数：每月可提交',
    secondaryreplacementcard: '次补卡',
    calculatedfromnaturalmonth: '（按自自然月计算）',
    limitedreplacementtime: '限制补卡时间：可申请过去',
    replacementcardwithindays: '天内的补卡',
    fillindaysTip: '（填写0天，则只能发起当天的补卡）',
    calculationofapprovaltime: '按审批单时长计算',
    calculatedbyclockingtime: '按打卡时长计算',
    overtimeTip1: '分钟之后，开始计算为加班',
    overtimeTip2: '当天加班少于',
    overtimeTip3: '分钟，不计算为加班',
    missingcard: '缺卡',
    leaveclearance: '销假',
    replacementcardnumber_error: '限制补卡次数格式错误',
    replacementcardtime_error: '限制补卡时间格式错误',
    pleaseenterintegers0720: '请输入0-720的整数',
    associatedapprovalform_empty: '请选择关联审批单',
    fixstatus_empty: '请选择修正状态',
    typeofleave_empty: '请选择请假类型',
    overtimetype_empty: '请选择加班类型',
    thetimecorrespondingtothestarttime_empty: '请选择开始时间对应时间',
    thetimecorrespondingtotheendtime_empty: '请选择结束时间对应时间',
    thefieldcorrespondingtoduration_empty: '请选择时长对应字段',
    thefieldcorrespondingtocardreplacementtime_empty: '请选择补卡时间对应字段',
    addattendancemachine: '添加考勤机',
    enterattendancemachine: '进入考勤机',
    pushTip: 'PUSH（支持B/S架构的考勤机）',
    offline: '脱机',
    attendancedockingaddress: '考勤对接地址',
    modeofcommunication: '通讯方式',
    attendancemachine_serialnumber: '考勤机-设备信息-序列号',
    ipaddress: 'IP地址',
    port: '端口',
    communicationpassword: '通讯密码',
    fetchtime: '获取数据时间',
    centralcontrol: '中控',
    ipcannotbeempty: 'IP不能为空',
    ipformaterror: 'IP格式错误',
    portcannotbeempty: '端口不能为空',
    communicationpasswordcannotbeempty: '通讯密码不能为空',
    syncmode: '同步模式',
    interfacetype: '接口类型',
    communicationmode: '通讯模式',
    attendancemachinehasbeenrepeated: '考勤机已重复',
    punchinaccordingtoattendancemachine: '根据考勤机打卡',
    connectattendancemachinesettings: '(请到插件管理-->连接考勤机中设置)',
    atleastoneattendancemethod: '请至少选择一项考勤方式',
    pleaseaddattendanceaddress: '请添加考勤地址',
    returnlist: '返回列表',
    annualleavesetting: '年假设置',
    switchoffsetting: '调休设置',
    holidaybalance: '假期余额',
    setemployeeannualleavebalance: '设置员工年假余额',
    annualleave: '年假',
    balancesendingmode: '余额发送方式',
    releasedate: '发放日期',
    correspondstotheentrydatein: '对应【成员管理】中的入职日期',
    quotaallocationrules: '配额配置规则',
    perpersonperyear: '每人每年发放',
    fullage: '司龄满',
    yeardiscontent: '年，不满',
    annualsabbatical: '年的，可休假',
    yearannualleaveallowed: '年，可休年假',
    expirationdate: '有效期',
    yearfromthedateofissue: '自发放日期起1周年',
    allowedextensionofvalidityperiod: '允许延长有效期',
    afterexpirybalanceretained: '超过有效期后，余额保留',
    setasrestshift: '设置计为调休',
    leaveofabsence: '请假调休',
    overtimeshiftonweekdays: '工作日加班调休',
    overtimeshiftonrestday: '休息日加班调休',
    workingovertimeonholidays: '节假日加班调休',
    press1: '按 1:',
    afterhowmanydaysofovertime: '加班多少天后作废',
    voidafterday: '天后作废',
    howmanydaysexpireaftertoday: '今日设置后，多少天过期',
    entrydate: '入职日期',
    record: '记录',
    editannualleave: '编辑年假',
    editleave: '编辑调休假',
    modifybalance: '修改余额',
    issuedautomaticallyonceayear: '每年自动发放1次',
    january1steachyear: '每年1月1日',
    annualemployeeentryday: '每年员工入职日',
    fixedquota: '固定额度',
    byseniority: '按司龄（本机构工龄为单位）',
    increase: '增加',
    reduce: '减少',
    annualleavecannotbeempty: '年假不能为空',
    fixedlimitformaterror: '固定额度格式错误',
    quotaruleformaterror: '配额规则格式错误',
    leaveleavecannotbeempty: '请假调休不能为空',
    atleastonetypeofovertime: '请至少选择一个加班类型',
    wrongformatofworkingovertimeshiftrate: '工作日加班调休倍率格式错误',
    wrongformatofovertimeshiftratioonrestday: '休息日加班调休倍率格式错误',
    wrongformatofovertimeworkingrateonholidays: '节假日加班调休倍率格式错误',
    invaliddayscannotbeempty: '作废天数不能为空',
    invalidnumberofdaysformattedincorrectly: '作废天数格式错误',
    calculatedastimeoff: '计为调休时长',
    transferleave: '调休假',
    absenteeism: '旷工',
    verify: '验证',
    sameattendancegroup_error: '请勾选同一个考勤组人员',
    length: '时长',
    originalshift: '原班次',
    timeperiod: '时间段',
    nodataavailable: '没有可操作的数据',
    effectiveRange: '打卡有效范围',
    ruleContent: '规则内容',
    // 20210305
    importtemplate: '考勤导入模板',
    test: '123'
  }
}
